/**
 * @name isPercentage
 * @description Checks if a string represents a percentage number.
 */
export const isPercentage = (string: string): boolean =>
  !!string.match(/^[0-9.]*%$/);
